export default __webpack_public_path__ + "static/big-4-desktop-9eb1f10f2458a9a930a571fd8dacd19e.jpg";